import { render, staticRenderFns } from "./BaseLoadTruck.vue?vue&type=template&id=465d3f1e&scoped=true"
import script from "./BaseLoadTruck.vue?vue&type=script&lang=js"
export * from "./BaseLoadTruck.vue?vue&type=script&lang=js"
import style0 from "./BaseLoadTruck.vue?vue&type=style&index=0&id=465d3f1e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "465d3f1e",
  null
  
)

export default component.exports